import V0Router from './v0'

const router = new VueRouter({
  routes: V0Router
})

export default router
